import { AbodeAggregateGeoType, MarketConditionsCommentaryFilterType } from '@aloft/toolkit-shared';

export const parseMarketConditionsGeoType = (
  filterType: MarketConditionsCommentaryFilterType,
): AbodeAggregateGeoType => {
  switch (filterType) {
    case 'Zip Code':
      return 'zip';
    case 'City':
      return 'city';
    case 'County':
      return 'county';
    default:
      throw new Error(`Unknown filter type: ${filterType as MarketConditionsCommentaryFilterType}`);
  }
};
